<div class="new-card primary">
  <div class="desc">
    Upload any additional documents, if asked by
    <strong>our team via phone, email or SMS</strong>
  </div>
  <form #documentsForm="ngForm" name="documentForm" id="documentForm" method="POST" class="zest-row"
    (ngSubmit)="closeUploader()">
    <div class="select-type input-field">
      <select name="additional_document" id="additional_document" required materialize="material_select"
        [(ngModel)]="additionalDocument" [materializeSelectOptions]="proofs">
        <option value="">Select document to upload</option>
        <option *ngFor="let item of proofs | KeysPipe" [value]="item.key">{{item.value}}</option>
      </select>
      <label for="additional_document" data-error="Select ID Proof">Additional documents</label>
    </div>
    <div class="col s12 qc-failed-warning" *ngIf="digioQcFailed">
      <div class="textCenter">
        <span [textContent]="errorMsg"></span>
      </div>
    </div>
    <div *ngIf="additionalDocument" class="drag-drop-cnt">
      <zest-file-upload-picker [imageFilesAllowed]="true" [previewRequired]="true" [labelId]="'inputfile'"
        [labelLargeText]="'<span>Drag a file here or </span><span class=&quot;text-bold&quot;>browse</span><span> from your computer to upload</span>'"
        [labelSmallText]="'Click here to add documents'" [fileType]="DigioNach ? 'image/png, image/jpeg' : 'image/*, application/pdf'"
        (selectFileEvent)="selectFile($event)"></zest-file-upload-picker>
      <p [hidden]="validAdditionalDocumentFile" class="error" [textContent]="invalidFileMessage"></p>
    </div>
    <div class="file-wrapper">
      <div class="drag-drop-cnt select-type">
        <zest-file-upload-progress *ngFor="let file of uploadedAdditionalDocuments; let currentIndex = index"
          [file]="file" [postUploadDownload]="true" [postUploadPreview]="true" [removableFile]="false"
          (removeFileEvent)="remove(file)" [postUploadDownload]="true" [postUploadPreview]="true">
        </zest-file-upload-progress>
      </div>
    </div>
    <div>
      <button type="button" class="back btn zest-btn outline" (click)="closeUploader()">BACK</button>
      <button type="submit" class="submit btn zest-btn" [disabled]="uploadedAdditionalDocuments?.length < 1">SAVE & CONTINUE</button>
    </div>
  </form>
</div>
